import * as Yup from 'yup';

// Defaults
export const formValues = {
    container: '',
    newContainer: ''
}

export const validation = () => (
    Yup.object({
        container: Yup.string()
            .required('Názov nádoby je povinný.')
            .min(1, 'Minimálny počet znakov je 1.')
            .max(25, 'Maximálny počet znakov je 25.'),
        newContainer: Yup.string()
            .required('Názov nádoby je povinný.')
            .min(1, 'Minimálny počet znakov je 1.')
            .max(25, 'Maximálny počet znakov je 25.'),

        })
        
);

